var $gXNCa$axecore = require("axe-core");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "init", () => $4fa36e821943b400$export$2cd8252107eb640b);
/* eslint-disable no-param-reassign */ /* eslint-disable no-empty */ /* eslint-disable no-console */ 
function $be25f1620a50bfcc$export$61fc7d43ac8f84b0(fn, wait) {
    let timeout = null;
    // eslint-disable-next-line func-names
    return function(...args) {
        // eslint-disable-next-line no-invalid-this
        const next = ()=>fn.apply(this, args);
        clearTimeout(timeout);
        timeout = setTimeout(next, wait);
    };
}


/* eslint-disable no-console */ function $a10c78ab1a941f96$export$30e0dc115df457ed() {
    return !localStorage.getItem("a11y-checker");
}
function $a10c78ab1a941f96$export$e20fbacbb41798b() {
    localStorage.setItem("a11y-checker", "");
}
function $a10c78ab1a941f96$export$d7c4a0dd6a4567e5() {
    localStorage.setItem("a11y-checker", "true");
}


function $4fa36e821943b400$var$domChange() {
    (0, ($parcel$interopDefault($gXNCa$axecore))).run({
        elementRef: true,
        runOnly: [
            "wcag2a",
            "wcag2aa",
            "wcag21a",
            "wcag21aa"
        ]
    }).then((results)=>{
        console.group("A11y Errors");
        results = results || {
            violations: []
        };
        // eslint-disable-next-line no-unused-expressions
        (results.violations || []).forEach((violation)=>{
            console.error(violation);
        });
        console.groupEnd("A11y Errors");
    });
}
function $4fa36e821943b400$export$2cd8252107eb640b() {
    if (window.MutationObserver && !(0, $a10c78ab1a941f96$export$30e0dc115df457ed)()) {
        const debounceObserve = (0, $be25f1620a50bfcc$export$61fc7d43ac8f84b0)($4fa36e821943b400$var$domChange, 1000);
        const observer = new MutationObserver(debounceObserve);
        observer.observe(document.querySelector("body"), {
            childList: true,
            subtree: true
        });
        document.addEventListener("DOMContentLoaded", debounceObserve);
        console.log("initalizing a11y detector");
        setTimeout(debounceObserve, 0);
    }
}


//# sourceMappingURL=main.js.map
